import React from "react";
import "./TopBanner.css";

const TopBanner = () => {
  return (
    <div className="top-banner">
      <div className="top-banner-left">
        <img
          src="/logo-banner.png"
          alt="Tęczowa Drużyna"
          className="top-banner-logo"
        />
        <a href="/" className="top-banner-title">
        Wycieczki
        </a>

      </div>

      <a
        href="https://teczowadruzyna.org"
        className="top-banner-link"
      >
        ← Powrót do strony głównej
      </a>
    </div>
  );
};

export default TopBanner;
